export default __webpack_public_path__ + "static/media/img-id-photo.a2e85ca0.png";